import React, {FunctionComponent} from 'react';
import styles from './PreparednessButton.module.css';

const PreparednessButton: FunctionComponent<{text: string, color: string, callback: Function, on: boolean}> = ({text, color, callback, on }) => {

  return (
    <button
      className={on ? styles.button : styles.button + " " + styles.off}
      onClick={() => callback(text)}
      style={{
        color: "white",
        opacity: on ? 1 : 0.5,
        backgroundColor: color,
        fontSize: "0.875rem",
      }}
    >
      {text}
    </button>
  );
}

export default PreparednessButton;
